import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const services = [
  'Commercial Paving',
  'Asphalt Paving',
  'Parking Lot Paving',
  'Parking Lot Repair',
  'Asphalt Repair',
  'Crack Filling',
  'Patching',
  'Resurfacing',
  'New Construction Installation',
  'Asphalt Sealcoating',
  'Asphalt Sealing',
  'Asphalt Crack Sealing',
  'Pavement Maintenance',
  'Parking Lot Striping',
  'Asphalt Milling',
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <span
              className={`text-xl md:text-2xl font-extrabold uppercase tracking-tight whitespace-nowrap ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              NJ Commercial Asphalt
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-6">
            {['Home', 'About', 'Testimonials', 'FAQ', 'Contact'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className={`text-sm font-semibold uppercase tracking-wide hover:text-yellow-400 transition-colors whitespace-nowrap ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                {item}
              </a>
            ))}
            {/* Services dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <button
                className={`text-sm font-semibold uppercase tracking-wide hover:text-yellow-400 transition-colors whitespace-nowrap flex items-center gap-1 ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                Services <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              {servicesOpen && (
                <div className="absolute top-full left-0 bg-white shadow-xl rounded-md py-2 min-w-[220px] z-50">
                  {services.map((s) => (
                    <a
                      key={s}
                      href="#services"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-400 hover:text-white transition-colors whitespace-nowrap"
                    >
                      {s}
                    </a>
                  ))}
                </div>
              )}
            </div>
            <a
              href="tel:8566776191"
              className="bg-yellow-400 text-gray-900 font-bold text-sm px-5 py-2 rounded-sm uppercase tracking-wide hover:bg-yellow-300 transition-colors whitespace-nowrap"
            >
              (856) 677-6191
            </a>
          </nav>

          {/* Mobile hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-2 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <span className={`block w-6 h-0.5 transition-all ${scrolled ? 'bg-gray-900' : 'bg-white'}`}></span>
            <span className={`block w-6 h-0.5 transition-all ${scrolled ? 'bg-gray-900' : 'bg-white'}`}></span>
            <span className={`block w-6 h-0.5 transition-all ${scrolled ? 'bg-gray-900' : 'bg-white'}`}></span>
          </button>
        </div>

        {/* Mobile phone bar */}
        <div className={`md:hidden text-center py-2 ${scrolled ? 'bg-gray-100' : 'bg-black/40'}`}>
          <a
            href="tel:8566776191"
            className="text-yellow-400 font-bold text-lg tracking-wide"
          >
            (856) 677-6191
          </a>
        </div>
      </header>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="fixed inset-0 bg-gray-900 z-50 flex flex-col overflow-y-auto">
          <div className="flex justify-between items-center px-6 py-5 border-b border-gray-700">
            <span className="text-white text-xl font-extrabold uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
              NJ Commercial Asphalt
            </span>
            <button onClick={() => setMobileOpen(false)} className="text-white text-3xl cursor-pointer">
              <i className="ri-close-line"></i>
            </button>
          </div>
          <nav className="flex flex-col px-6 py-4 gap-4">
            {['Home', 'About', 'Services', 'Testimonials', 'FAQ', 'Contact'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                onClick={() => setMobileOpen(false)}
                className="text-white text-lg font-semibold uppercase border-b border-gray-700 pb-3 hover:text-yellow-400 transition-colors"
              >
                {item}
              </a>
            ))}
            <a
              href="tel:8566776191"
              className="mt-4 bg-yellow-400 text-gray-900 font-bold text-center py-3 rounded uppercase tracking-wide"
            >
              Call (856) 677-6191
            </a>
          </nav>
        </div>
      )}
    </>
  );
}
